import { render } from "./Sub.vue?vue&type=template&id=4ea92dee&scoped=true"
const script = {}

import "./Sub.vue?vue&type=style&index=0&id=4ea92dee&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea92dee"]])

export default __exports__